import { render, staticRenderFns } from "./ExportIndividualWageTypes.vue?vue&type=template&id=0e5898b8&scoped=true&"
import script from "./ExportIndividualWageTypes.vue?vue&type=script&lang=js&"
export * from "./ExportIndividualWageTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5898b8",
  null
  
)

export default component.exports